import PropTypes from 'prop-types';
import tw from 'twin.macro';

const HEADER_SIZES = {
  default: tw`text-xl leading-[26px]`,
  large: tw`text-2xl leading-[30px]`,
};
function Header({ size = 'default', ...props }) {
  return (
    <h3 tw="text-dark font-semibold" css={HEADER_SIZES[size]} {...props} />
  );
}
Header.propTypes = {
  size: PropTypes.oneOf(Object.keys(HEADER_SIZES)),
};

const TEXT_BLOCK_SIZES = {
  small: tw`text-sm leading-[21px]`,
  default: tw`text-base`,
};

function TextBlock({ size = 'default', ...props }) {
  return <p tw="text-gray-800" css={TEXT_BLOCK_SIZES[size]} {...props} />;
}
TextBlock.propTypes = {
  size: PropTypes.oneOf(Object.keys(TEXT_BLOCK_SIZES)),
};

export { Header, TextBlock };
